import styled, { keyframes, css } from 'styled-components';

import colors from '../../../../../styles/colors';
import { ReactComponent as TrashIcon } from '../../../../../assets/icons/v2/trash.svg';
import { ReactComponent as EditIcon } from '../../../../../assets/icons/v2/edit-blue.svg';
import UserProfileCard from '../../../../components/UserProfileCard';

const FLASH_CLASSNAME = 'highlight-comment';
const FLASH_SECONDS = 4;

const flashShadow = keyframes`
  0% {
    box-shadow: inset 0 0 10px 2px rgba(0, 0, 0, 0.3);
  }
  100% {
    box-shadow: inset 0 0 0 0 rgba(0, 0, 0, 0);
  }
`;

const iconStyle = css`
  width: 16px;
  height: 16px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 5px;
  padding: 10px 20px;
  border-bottom: 1px solid ${colors.shades.gamma5};

  &.${FLASH_CLASSNAME} {
    animation: ${flashShadow} ${FLASH_SECONDS}s ease-in-out;
  }
`;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const CommentText = styled.div`
  width: 100%;
  font-size: 15px;
  white-space: pre-wrap;
`;

const CommentAttachmentsWrapper = styled.div`
  width: 50%;
`;

const DateText = styled.span`
  color: ${colors.shades.beta1};
  font-size: 12px;
  text-wrap: nowrap;
`;

const StyledUserProfileCard = styled(UserProfileCard)`
  a {
    text-decoration: none;
    width: fit-content;
  }
`;

const ActionButtonContainer = styled.div`
  display: flex;
  align-items: center;
`;

const BottomRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const StyledRemoveIcon = styled(TrashIcon)`
  ${iconStyle}
`;

const StyledEditIcon = styled(EditIcon)`
  ${iconStyle}
`;

export {
  FLASH_CLASSNAME,
  FLASH_SECONDS,
  Container,
  HeaderContainer,
  CommentText,
  CommentAttachmentsWrapper,
  DateText,
  StyledUserProfileCard,
  BottomRow,
  StyledRemoveIcon,
  ActionButtonContainer,
  StyledEditIcon,
};
